import { Module } from "./Module";

export class EspModule extends Module{
    transputs!: string[]
}